export const PESQUISA_LIST = "PESQUISA_LIST"
export const PESQUISA_CHANGE = "PESQUISA_CHANGE"
export const PESQUISA_LOADING = "PESQUISA_LOADING"

export const PESQUISA_VALIDACAO_ADD = "PESQUISA_VALIDACAO_ADD"
export const PESQUISA_VALIDACAO_REMOVE = "PESQUISA_VALIDACAO_REMOVE"
export const PESQUISA_SAVING = "PESQUISA_SAVING"